import { FormValues } from './index.context'

export const defaultValues: FormValues = {
  clientId: null,
  accountIds: [],
  checkNumber: '',
  amount: '',
  date: [],
}
